// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../web/myagent/app/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../web/myagent/app/node_modules/css-loader/dist/cjs.js!../styles/variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: var(--spacing-xl) var(--spacing-2xl);
  max-width: 640px;
  margin: 0 auto;
  width: 100%;
}

/* Header */
.cd-header {
  display: flex;
  align-items: flex-start;
  gap: var(--spacing-lg);
  padding-bottom: var(--spacing-lg);
  border-bottom: 1px solid var(--glass-border);
}

.cd-avatar {
  width: 56px;
  height: 56px;
  border-radius: var(--radius-full);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
}

.cd-status {
  position: absolute;
  bottom: 2px;
  right: 2px;
  width: 12px;
  height: 12px;
  border-radius: var(--radius-full);
  border: 2px solid var(--bg-primary);
}

.cd-status.online {
  background: var(--color-success);
  box-shadow: 0 0 8px var(--color-success-glow);
}

.cd-status.offline {
  background: var(--text-tertiary);
}

.cd-info {
  flex: 1;
  min-width: 0;
}

.cd-name {
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-semibold);
  color: var(--text-primary);
  letter-spacing: var(--letter-spacing-tight);
}

.cd-type {
  font-size: var(--font-size-sm);
  color: var(--text-tertiary);
  margin-top: 2px;
}

.cd-status-text {
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-xs);
}

.cd-status-text.online {
  color: var(--color-success);
}

.cd-status-text.offline {
  color: var(--text-tertiary);
}

.cd-desc {
  font-size: var(--font-size-sm);
  color: var(--text-secondary);
  margin-top: var(--spacing-sm);
  line-height: var(--line-height-normal);
}

/* Actions */
.cd-actions {
  display: flex;
  gap: var(--spacing-sm);
  padding: var(--spacing-lg) 0;
  border-bottom: 1px solid var(--glass-border);
}

.cd-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding: var(--spacing-sm) var(--spacing-lg);
  border-radius: var(--radius-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: all var(--transition-fast);
  font-family: var(--font-family);
}

.cd-btn-primary {
  background: var(--color-primary);
  color: white;
  border: none;
}

.cd-btn-primary:hover {
  background: var(--color-primary-hover);
  box-shadow: 0 0 16px var(--color-primary-glow);
}

.cd-btn-danger {
  background: none;
  color: var(--text-tertiary);
  border: 1px solid var(--glass-border);
}

.cd-btn-danger:hover {
  color: var(--color-error);
  border-color: var(--color-error);
}

/* Config section */
.cd-config {
  padding-top: var(--spacing-lg);
}

.cd-config-title {
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-wider);
  color: var(--text-tertiary);
  margin-bottom: var(--spacing-md);
}

.cd-config-fields {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.cd-field {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.cd-field-label {
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  color: var(--text-secondary);
}

.cd-field-input {
  padding: var(--spacing-sm) var(--spacing-md);
  background: var(--input-bg);
  border: 1px solid var(--input-border);
  border-radius: var(--radius-md);
  color: var(--text-primary);
  font-size: var(--font-size-sm);
  font-family: var(--font-family);
  transition: border-color var(--transition-fast);
}

.cd-field-input:focus {
  outline: none;
  border-color: var(--input-focus-border);
  box-shadow: var(--input-focus-glow);
}

.cd-field-textarea {
  resize: vertical;
  min-height: 60px;
  font-family: var(--font-family-mono);
  line-height: var(--line-height-normal);
}

.cd-config-footer {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  padding-top: var(--spacing-md);
}

.cd-config-error {
  font-size: var(--font-size-xs);
  color: var(--color-error);
}

.cd-config-loading {
  text-align: center;
  padding: var(--spacing-lg);
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
}

/* Mobile */
@media (max-width: 768px) {
  .contact-detail {
    padding: var(--spacing-lg) var(--spacing-md);
  }
}
`, "",{"version":3,"sources":["webpack://./../../../packages/apps/myagent/myagent_ui/src/components/ContactDetail.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,6CAA6C;EAC7C,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,iCAAiC;EACjC,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,eAAe;EACf,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,yBAAyB;EACzB,2CAA2C;EAC3C,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,WAAW;AACX;EACE;IACE,4CAA4C;EAC9C;AACF","sourcesContent":["@import '../styles/variables.css';\n\n.contact-detail {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow-y: auto;\n  padding: var(--spacing-xl) var(--spacing-2xl);\n  max-width: 640px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* Header */\n.cd-header {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--spacing-lg);\n  padding-bottom: var(--spacing-lg);\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.cd-avatar {\n  width: 56px;\n  height: 56px;\n  border-radius: var(--radius-full);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.cd-status {\n  position: absolute;\n  bottom: 2px;\n  right: 2px;\n  width: 12px;\n  height: 12px;\n  border-radius: var(--radius-full);\n  border: 2px solid var(--bg-primary);\n}\n\n.cd-status.online {\n  background: var(--color-success);\n  box-shadow: 0 0 8px var(--color-success-glow);\n}\n\n.cd-status.offline {\n  background: var(--text-tertiary);\n}\n\n.cd-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.cd-name {\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-semibold);\n  color: var(--text-primary);\n  letter-spacing: var(--letter-spacing-tight);\n}\n\n.cd-type {\n  font-size: var(--font-size-sm);\n  color: var(--text-tertiary);\n  margin-top: 2px;\n}\n\n.cd-status-text {\n  font-size: var(--font-size-sm);\n  margin-top: var(--spacing-xs);\n}\n\n.cd-status-text.online {\n  color: var(--color-success);\n}\n\n.cd-status-text.offline {\n  color: var(--text-tertiary);\n}\n\n.cd-desc {\n  font-size: var(--font-size-sm);\n  color: var(--text-secondary);\n  margin-top: var(--spacing-sm);\n  line-height: var(--line-height-normal);\n}\n\n/* Actions */\n.cd-actions {\n  display: flex;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-lg) 0;\n  border-bottom: 1px solid var(--glass-border);\n}\n\n.cd-btn {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding: var(--spacing-sm) var(--spacing-lg);\n  border-radius: var(--radius-md);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  cursor: pointer;\n  transition: all var(--transition-fast);\n  font-family: var(--font-family);\n}\n\n.cd-btn-primary {\n  background: var(--color-primary);\n  color: white;\n  border: none;\n}\n\n.cd-btn-primary:hover {\n  background: var(--color-primary-hover);\n  box-shadow: 0 0 16px var(--color-primary-glow);\n}\n\n.cd-btn-danger {\n  background: none;\n  color: var(--text-tertiary);\n  border: 1px solid var(--glass-border);\n}\n\n.cd-btn-danger:hover {\n  color: var(--color-error);\n  border-color: var(--color-error);\n}\n\n/* Config section */\n.cd-config {\n  padding-top: var(--spacing-lg);\n}\n\n.cd-config-title {\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-medium);\n  text-transform: uppercase;\n  letter-spacing: var(--letter-spacing-wider);\n  color: var(--text-tertiary);\n  margin-bottom: var(--spacing-md);\n}\n\n.cd-config-fields {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md);\n}\n\n.cd-field {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-xs);\n}\n\n.cd-field-label {\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  color: var(--text-secondary);\n}\n\n.cd-field-input {\n  padding: var(--spacing-sm) var(--spacing-md);\n  background: var(--input-bg);\n  border: 1px solid var(--input-border);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n  font-size: var(--font-size-sm);\n  font-family: var(--font-family);\n  transition: border-color var(--transition-fast);\n}\n\n.cd-field-input:focus {\n  outline: none;\n  border-color: var(--input-focus-border);\n  box-shadow: var(--input-focus-glow);\n}\n\n.cd-field-textarea {\n  resize: vertical;\n  min-height: 60px;\n  font-family: var(--font-family-mono);\n  line-height: var(--line-height-normal);\n}\n\n.cd-config-footer {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-sm);\n  padding-top: var(--spacing-md);\n}\n\n.cd-config-error {\n  font-size: var(--font-size-xs);\n  color: var(--color-error);\n}\n\n.cd-config-loading {\n  text-align: center;\n  padding: var(--spacing-lg);\n  color: var(--text-secondary);\n  font-size: var(--font-size-sm);\n}\n\n/* Mobile */\n@media (max-width: 768px) {\n  .contact-detail {\n    padding: var(--spacing-lg) var(--spacing-md);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
